/** @typedef {import('@utahdts/utah-design-system').FormElementSizes} FormElementSizes */
/** @enum {FormElementSizes} */
export const formElementSizesEnum = {
  SMALL3X: /** @type {FormElementSizes} */ ('small3x'),
  SMALL2X: /** @type {FormElementSizes} */ ('small2x'),
  SMALL1X: /** @type {FormElementSizes} */ ('small1x'),
  SMALL: /** @type {FormElementSizes} */ ('small'),
  MEDIUM: /** @type {FormElementSizes} */ ('medium'),
  LARGE: /** @type {FormElementSizes} */ ('large'),
  LARGE1X: /** @type {FormElementSizes} */ ('large1x'),
};
